<script>
    import { mode, timestamp } from '../store';
    import { Button, Ripple, Dialog, Icon, AppBar } from 'svelte-materialify';
    import { mdiClose, mdiLock, mdiLockOpen } from '@mdi/js'
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let window;

    let isTutorialVisible = false;

</script>

<main>

    <div class="btn-administration">
        <Button depressed style="background: transparent" fab on:click={() => dispatch("openAdmin")}>
            <Icon class="green-text text-darken-3" path={mdiLock} />
        </Button>
    </div>

    <div class="info-container">

        <img src="./media/logo.svg" alt="">

    </div>

    <div class="action-container">

        <div class="double-button rounded-lg elevation-1">

            <div class="top-button pa-3 pl-6 pr-6 text-center green" use:Ripple on:click={() => {
                mode.set("start");
                timestamp.set(new Date());
                window.next();
            }}>
                <span class="text-button">
                    Apri provetta
                </span>
            </div>

            <div class="bottom-button pa-3 pl-6 pr-6 text-center white green-text text-darken-1" use:Ripple on:click={() => {
                mode.set("end");
                timestamp.set(new Date());
                window.next();
            }}>
                <span class="text-button">
                    Chiudi provetta
                </span>
            </div>

        </div>

        <div style="width: 100%; height: auto" class="d-flex justify-center">
            <Button outlined depressed class="green-text" on:click={() => isTutorialVisible = true}>
                Come funziona?
            </Button>
        </div>

    </div>

    <Dialog class="white rounded black-text" style="overflow-y:auto" bind:active={isTutorialVisible}>

        <AppBar flat class="white">
            <span slot="icon">
                <Button icon size="small" on:click={() => isTutorialVisible = false}>
                    <Icon path={mdiClose} />
                </Button>
            </span>
            <span slot="title">
                Come funziona?
            </span>
        </AppBar>

        <div class="pa-3 content">

            <h6 class="text-h6">
                Apertura provetta
            </h6>
    
            <div class="text-body-1 mt-1">
                Per aprire una provetta ti basterà seguire la procedura guidata, per iniziare clicca sul pulsante <b>APRI PROVETTA</b>
            </div>
    
            <h6 class="text-h6 mt-4">
                Attesa
            </h6>
    
            <div class="text-body-1 mt-1">
                Una volta completata la procedura, dovrai attendere 21 giorni prima di proseguire con la chiusura, sarai avvisato tramite email e notifica il giorno prima
            </div>
    
            <h6 class="text-h6 mt-4">
                Chiusura provetta
            </h6>
    
            <div class="text-body-1 mt-1 mb-5">
                Al termine dei 21 giorni per chiudere la provetta clicca sul pulsante <b>CHIUDI PROVETTA</b> e segui nuovamente la procedura guidata
            </div>

        </div>

        <div class="pa-3">

            <Button block depressed class="green white-text pt-2 pb-2" on:click={() => isTutorialVisible = false}>
                Va bene
            </Button>

        </div>

    </Dialog>



</main>

<style>

    main {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
    }

    main > .btn-administration {
        position: absolute;
        top: 16px;
        right: 16px;
    }

    main > .info-container {
        flex: 3;
        display: grid;
        place-items: center;
    }

    main > .info-container > img {
        width: 85%;
    }

    main > .action-container {
        flex: 2;
        display: grid;
        place-items: center;
    }

    main > .action-container > .double-button {
        user-select: none;
        cursor: pointer;
        overflow: hidden;
        border: 3px solid #4caf50;
        background-color: #4caf50;
    }
    
    .content {
        height: auto;
        max-height: 50vh;
        overflow-y: auto;
    }

</style>